import { createReducer, on } from '@ngrx/store';

import {
    CloseMenu,
    OpenMenu,
    SetLastSection,
    SetActiveCategories,
} from './menu-categories.actions';
import { MenuCategoriesState } from './menu-categories.state';

export const categoryInitialState: MenuCategoriesState = {
    isLoading: true,
    header: {
        isOpen: false,
        lastSection: undefined,
        showInHeader: '0',
        activeCategories: [
            {
                activeCategoryIdLvl1: undefined,
                activeCategoryIdLvl2: undefined,
                activeCategoryIdLvl3: undefined,
            },
            {
                activeCategoryIdLvl1: undefined,
                activeCategoryIdLvl2: undefined,
                activeCategoryIdLvl3: undefined,
            },
        ],
    },
};

export const MenuCategoriesReducer = createReducer(
    categoryInitialState,
    on(SetActiveCategories, (state, { data }): MenuCategoriesState => {
        return {
            ...state,
            header: {
                ...state.header,
                activeCategories: data,
            },
        };
    }),
    on(SetLastSection, (state, { section }): MenuCategoriesState => {
        return { ...state, header: { ...state.header, lastSection: section } };
    }),
    on(OpenMenu, (state) => {
        return { ...state, header: { ...state.header, isOpen: true } };
    }),
    on(CloseMenu, (state) => {
        return { ...state, header: { ...state.header, isOpen: false } };
    }),
);
